export default __webpack_public_path__ + "static/media/TransistorImg.9413d30d.jpg";